import { HiMail, HiPhone, HiExternalLink } from 'react-icons/hi';
import HeroSection from '../components/ui/HeroSection';
import ChalkboardBackground from '../components/ui/ChalkboardBackground';
import { SectionHeader } from '../components/ui/Section';
import ContactForm from '../components/forms/ContactForm';
import siteContent from '../data/siteContent.json';
import heroBg from '../assets/images/header-banner.png';
import Seo from '../components/Seo';

export default function Contact() {
  return (
    <>
      <Seo
        title="Contact"
        description="Get in touch with Blush & Bobby for Kansas City bridal hair and makeup. Call (816) 654-5289 or send a message to start planning your wedding day look."
        path="/contact"
      />
      <HeroSection
        title="Get in Touch"
        backgroundImage={heroBg}
        opacity={0.7}
        overlayColor="bg-dusty-rose/25"
      />

      <ChalkboardBackground className="py-16 md:py-24">
        <div className="container-custom">
          <SectionHeader
            title="Inquire About Your Event"
            subtitle="Bridal, special events, and med spa inquiries — we'd love to hear from you."
            dark={true}
          />
          <div className="max-w-3xl mx-auto">
            <ContactForm />
          </div>
        </div>
      </ChalkboardBackground>

      <section className="py-12 md:py-16 checkered-bg bg-charcoal-dark">
        <div className="container-custom">
          <SectionHeader title="Prefer to reach out directly?" dark={true} />
          <div className="max-w-2xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-6">
            <a
              href={`mailto:${siteContent.email}`}
              className="flex items-center gap-4 bg-black/40 border border-dusty-rose/30 rounded-2xl p-6 hover:border-dusty-rose transition-colors"
            >
              <span className="inline-flex items-center justify-center w-12 h-12 border border-dusty-rose/40 rounded-full">
                <HiMail className="h-6 w-6 text-dusty-rose" />
              </span>
              <span>
                <span className="block text-xs uppercase tracking-wider text-chalk/60">Email</span>
                <span className="block text-chalk font-medium">{siteContent.email}</span>
              </span>
            </a>
            <a
              href={`tel:${siteContent.phone.replace(/[^\d+]/g, '')}`}
              className="flex items-center gap-4 bg-black/40 border border-dusty-rose/30 rounded-2xl p-6 hover:border-dusty-rose transition-colors"
            >
              <span className="inline-flex items-center justify-center w-12 h-12 border border-dusty-rose/40 rounded-full">
                <HiPhone className="h-6 w-6 text-dusty-rose" />
              </span>
              <span>
                <span className="block text-xs uppercase tracking-wider text-chalk/60">Phone</span>
                <span className="block text-chalk font-medium">{siteContent.phone}</span>
              </span>
            </a>
          </div>

          <div className="text-center mt-10">
            <a
              href={siteContent.social.linktree}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-dusty-rose hover:text-chalk transition-colors font-semibold uppercase tracking-wider text-sm"
            >
              Ready to book? Check availability
              <HiExternalLink className="h-4 w-4" />
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
